// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ActivityAnswerRepresentation } from './ActivityAnswerRepresentation'
import {
  ActivityAnswerRepresentationFromJSON,
  ActivityAnswerRepresentationFromJSONTyped,
  ActivityAnswerRepresentationToJSON,
} from './ActivityAnswerRepresentation'
import type { ActivityFeedbackDataRepresentation } from './ActivityFeedbackDataRepresentation'
import {
  ActivityFeedbackDataRepresentationFromJSON,
  ActivityFeedbackDataRepresentationFromJSONTyped,
  ActivityFeedbackDataRepresentationToJSON,
} from './ActivityFeedbackDataRepresentation'
import type { ActivityFeedbackRepresentation } from './ActivityFeedbackRepresentation'
import {
  ActivityFeedbackRepresentationFromJSON,
  ActivityFeedbackRepresentationFromJSONTyped,
  ActivityFeedbackRepresentationToJSON,
} from './ActivityFeedbackRepresentation'
import type { LegendsFeedbackRepresentation } from './LegendsFeedbackRepresentation'
import {
  LegendsFeedbackRepresentationFromJSON,
  LegendsFeedbackRepresentationFromJSONTyped,
  LegendsFeedbackRepresentationToJSON,
} from './LegendsFeedbackRepresentation'
import type { SimpleActivityRepresentation } from './SimpleActivityRepresentation'
import {
  SimpleActivityRepresentationFromJSON,
  SimpleActivityRepresentationFromJSONTyped,
  SimpleActivityRepresentationToJSON,
} from './SimpleActivityRepresentation'
import type { SimpleProfileRepresentation } from './SimpleProfileRepresentation'
import {
  SimpleProfileRepresentationFromJSON,
  SimpleProfileRepresentationFromJSONTyped,
  SimpleProfileRepresentationToJSON,
} from './SimpleProfileRepresentation'
import type { WritingStatus } from './WritingStatus'
import {
  WritingStatusFromJSON,
  WritingStatusFromJSONTyped,
  WritingStatusToJSON,
} from './WritingStatus'

/**
 *
 * @export
 * @interface ActivityResultDataRepresentation
 */
export interface ActivityResultDataRepresentation {
  /**
   *
   * @type {SimpleActivityRepresentation}
   * @memberof ActivityResultDataRepresentation
   */
  activity?: SimpleActivityRepresentation
  /**
   *
   * @type {Array<ActivityAnswerRepresentation>}
   * @memberof ActivityResultDataRepresentation
   */
  answers?: Array<ActivityAnswerRepresentation> | null
  /**
   *
   * @type {Array<ActivityFeedbackDataRepresentation>}
   * @memberof ActivityResultDataRepresentation
   */
  feedbacks?: Array<ActivityFeedbackDataRepresentation> | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultDataRepresentation
   */
  feedbackCount?: number | null
  /**
   *
   * @type {SimpleProfileRepresentation}
   * @memberof ActivityResultDataRepresentation
   */
  user?: SimpleProfileRepresentation
  /**
   *
   * @type {Array<SimpleProfileRepresentation>}
   * @memberof ActivityResultDataRepresentation
   */
  users?: Array<SimpleProfileRepresentation> | null
  /**
   *
   * @type {Array<LegendsFeedbackRepresentation>}
   * @memberof ActivityResultDataRepresentation
   */
  legendsNlpFeedbackScores?: Array<LegendsFeedbackRepresentation> | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultDataRepresentation
   */
  eventId?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultDataRepresentation
   */
  resultId: string
  /**
   *
   * @type {string}
   * @memberof ActivityResultDataRepresentation
   */
  userId: string
  /**
   *
   * @type {string}
   * @memberof ActivityResultDataRepresentation
   */
  activityId: string
  /**
   *
   * @type {string}
   * @memberof ActivityResultDataRepresentation
   */
  assignmentId?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultDataRepresentation
   */
  assignmentTaskId?: number | null
  /**
   *
   * @type {boolean}
   * @memberof ActivityResultDataRepresentation
   */
  isQuest?: boolean
  /**
   *
   * @type {WritingStatus}
   * @memberof ActivityResultDataRepresentation
   */
  status: WritingStatus
  /**
   *
   * @type {number}
   * @memberof ActivityResultDataRepresentation
   */
  score?: number | null
  /**
   *
   * @type {Date}
   * @memberof ActivityResultDataRepresentation
   */
  createdDate?: Date
  /**
   *
   * @type {Date}
   * @memberof ActivityResultDataRepresentation
   */
  updatedDate?: Date | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultDataRepresentation
   */
  reflection?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultDataRepresentation
   */
  words?: number | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultDataRepresentation
   */
  userTargetWordCount?: number | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultDataRepresentation
   */
  userTitle?: string | null
  /**
   *
   * @type {Array<ActivityFeedbackRepresentation>}
   * @memberof ActivityResultDataRepresentation
   */
  resultFeedback?: Array<ActivityFeedbackRepresentation> | null
}

/**
 * Check if a given object implements the ActivityResultDataRepresentation interface.
 */
export function instanceOfActivityResultDataRepresentation(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'resultId' in value
  isInstance = isInstance && 'userId' in value
  isInstance = isInstance && 'activityId' in value
  isInstance = isInstance && 'status' in value

  return isInstance
}

export function ActivityResultDataRepresentationFromJSON(
  json: any,
): ActivityResultDataRepresentation {
  return ActivityResultDataRepresentationFromJSONTyped(json, false)
}

export function ActivityResultDataRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityResultDataRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activity: !exists(json, 'activity')
      ? undefined
      : SimpleActivityRepresentationFromJSON(json['activity']),
    answers: !exists(json, 'answers')
      ? undefined
      : json['answers'] === null
        ? null
        : (json['answers'] as Array<any>).map(
            ActivityAnswerRepresentationFromJSON,
          ),
    feedbacks: !exists(json, 'feedbacks')
      ? undefined
      : json['feedbacks'] === null
        ? null
        : (json['feedbacks'] as Array<any>).map(
            ActivityFeedbackDataRepresentationFromJSON,
          ),
    feedbackCount: !exists(json, 'feedback_count')
      ? undefined
      : json['feedback_count'],
    user: !exists(json, 'user')
      ? undefined
      : SimpleProfileRepresentationFromJSON(json['user']),
    users: !exists(json, 'users')
      ? undefined
      : json['users'] === null
        ? null
        : (json['users'] as Array<any>).map(
            SimpleProfileRepresentationFromJSON,
          ),
    legendsNlpFeedbackScores: !exists(json, 'legends_nlp_feedback_scores')
      ? undefined
      : json['legends_nlp_feedback_scores'] === null
        ? null
        : (json['legends_nlp_feedback_scores'] as Array<any>).map(
            LegendsFeedbackRepresentationFromJSON,
          ),
    eventId: !exists(json, 'event_id') ? undefined : json['event_id'],
    resultId: json['result_id'],
    userId: json['user_id'],
    activityId: json['activity_id'],
    assignmentId: !exists(json, 'assignment_id')
      ? undefined
      : json['assignment_id'],
    assignmentTaskId: !exists(json, 'assignment_task_id')
      ? undefined
      : json['assignment_task_id'],
    isQuest: !exists(json, 'is_quest') ? undefined : json['is_quest'],
    status: WritingStatusFromJSON(json['status']),
    score: !exists(json, 'score') ? undefined : json['score'],
    createdDate: !exists(json, 'created_date')
      ? undefined
      : new Date(json['created_date']),
    updatedDate: !exists(json, 'updated_date')
      ? undefined
      : json['updated_date'] === null
        ? null
        : new Date(json['updated_date']),
    reflection: !exists(json, 'reflection') ? undefined : json['reflection'],
    words: !exists(json, 'words') ? undefined : json['words'],
    userTargetWordCount: !exists(json, 'user_target_word_count')
      ? undefined
      : json['user_target_word_count'],
    userTitle: !exists(json, 'user_title') ? undefined : json['user_title'],
    resultFeedback: !exists(json, 'result_feedback')
      ? undefined
      : json['result_feedback'] === null
        ? null
        : (json['result_feedback'] as Array<any>).map(
            ActivityFeedbackRepresentationFromJSON,
          ),
  }
}

export function ActivityResultDataRepresentationToJSON(
  value?: ActivityResultDataRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activity: SimpleActivityRepresentationToJSON(value.activity),
    answers:
      value.answers === undefined
        ? undefined
        : value.answers === null
          ? null
          : (value.answers as Array<any>).map(
              ActivityAnswerRepresentationToJSON,
            ),
    feedbacks:
      value.feedbacks === undefined
        ? undefined
        : value.feedbacks === null
          ? null
          : (value.feedbacks as Array<any>).map(
              ActivityFeedbackDataRepresentationToJSON,
            ),
    feedback_count: value.feedbackCount,
    user: SimpleProfileRepresentationToJSON(value.user),
    users:
      value.users === undefined
        ? undefined
        : value.users === null
          ? null
          : (value.users as Array<any>).map(SimpleProfileRepresentationToJSON),
    legends_nlp_feedback_scores:
      value.legendsNlpFeedbackScores === undefined
        ? undefined
        : value.legendsNlpFeedbackScores === null
          ? null
          : (value.legendsNlpFeedbackScores as Array<any>).map(
              LegendsFeedbackRepresentationToJSON,
            ),
    event_id: value.eventId,
    result_id: value.resultId,
    user_id: value.userId,
    activity_id: value.activityId,
    assignment_id: value.assignmentId,
    assignment_task_id: value.assignmentTaskId,
    is_quest: value.isQuest,
    status: WritingStatusToJSON(value.status),
    score: value.score,
    created_date:
      value.createdDate === undefined
        ? undefined
        : value.createdDate.toISOString(),
    updated_date:
      value.updatedDate === undefined
        ? undefined
        : value.updatedDate === null
          ? null
          : value.updatedDate.toISOString(),
    reflection: value.reflection,
    words: value.words,
    user_target_word_count: value.userTargetWordCount,
    user_title: value.userTitle,
    result_feedback:
      value.resultFeedback === undefined
        ? undefined
        : value.resultFeedback === null
          ? null
          : (value.resultFeedback as Array<any>).map(
              ActivityFeedbackRepresentationToJSON,
            ),
  }
}
